/**
 * CasualCompetitors 页面筛选器组件
 */
import React, { useMemo } from 'react';
import classnames from 'classnames';
import Filter from '@intelligence/components/Filter';
import { isEmpty } from '@intelligence/v3/utils/common';
import * as filterKeyMap from '@intelligence/components/Filter/FilterBase/_config';
import { REVENUE_SCOPE_VALUES } from '@intelligence/utils/revenueScope';

interface ICasualCompetitorsFilterProps extends IBaseProps {
  entityType: string;
  /** 通用加载状态，为true时所有筛选条件都显示加载状态 */
  loading?: boolean;
  regionOptions?: IRegion[] | null;
  rangeTimeComponentDefault?: IRecord | null;
  defaultValue?: IRecord;
  showRevenueScopeSwitcher?: boolean;
  value: IRecord;
  onChange?: (value: IRecord, apiValue: IRecord) => void;
  onReset?: (value: IRecord) => void;
}

const CasualCompetitorsFilter: React.FC<ICasualCompetitorsFilterProps> = (props) => {
  const {
    style,
    className,
    entityType,
    loading,
    regionOptions,
    rangeTimeComponentDefault,
    defaultValue,
    showRevenueScopeSwitcher,
    value,
    onChange,
    onReset,
  } = props;

  // 筛选器配置
  const inputList = useMemo(() => {
    const list: Record<string, any>[] = [
      {
        type: filterKeyMap.RANGE_TIME,
        key: filterKeyMap.RANGE_TIME,
        extendFilterType: filterKeyMap.RANGE_TIME_EXTEND_TYPE.singleDate,
        typeList: ['date', 'month'], // 支持日粒度和月粒度
        calendarType: 'date',
        showSelectType: true, // 显示粒度切换
        showShortcut: true,
        componentDefault: rangeTimeComponentDefault,
        default: [undefined, undefined],
        loading,
      },
      {
        type: filterKeyMap.REGION,
        key: filterKeyMap.REGION,
        entityType,
        extendFilterType: filterKeyMap.REGION_EXTEND_TYPE.common,
        default: defaultValue?.[filterKeyMap.REGION],
        visible: 1,
        loading,
        options: isEmpty(regionOptions) ? [] : regionOptions,
      },
      {
        type: filterKeyMap.PLATFORM,
        key: filterKeyMap.PLATFORM,
        default: { value: ['appstore', 'googleplay'] },
        visible: 1,
        loading,
      },
    ];

    if (showRevenueScopeSwitcher) {
      list.push({
        key: filterKeyMap.REVENUE_SCOPE,
        default: defaultValue?.[filterKeyMap.REVENUE_SCOPE] || {
          value: REVENUE_SCOPE_VALUES.EXCLUDING,
        },
        visible: 1,
        loading,
        controlType: 'switch',
      });
    }

    return list;
  }, [loading, entityType, showRevenueScopeSwitcher, regionOptions, rangeTimeComponentDefault, defaultValue]);

  return (
    <Filter
      style={style}
      className={classnames('dbh-casual-competitors-filter', className)}
      showButton={false}
      inputList={inputList}
      defaultValue={defaultValue}
      value={value}
      onConfirm={onChange}
      onReset={onReset}
    />
  );
};

export default CasualCompetitorsFilter;
